import { render, staticRenderFns } from "./TitledOverlay.vue?vue&type=template&id=26db8d34&"
import script from "./TitledOverlay.vue?vue&type=script&lang=js&"
export * from "./TitledOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports